import React, { useEffect } from 'react';

const StatusButton = ({
  backgroundColor,
  textColor,
  imgSrc,
  border,
  status,
  onClick,
  clickable,
  topButtons,
}: any) => {
  const buttonStyle = {
    backgroundColor: backgroundColor,
    cursor: clickable ? 'pointer' : 'default',
    opacity: 1,
    border: border,
  };

  return (
    <div
      className='statusButton'
      style={buttonStyle}
      onClick={clickable ? onClick : undefined}
    >
      <div className='statusButtonElement gap-1'>
        <div>
          <img
            src={imgSrc}
            style={{ width: '1rem', height: '1rem' }}
            alt={status}
          />
        </div>
        <p style={{ color: textColor }}>{status}</p>
      </div>
    </div>
  );
};

export default StatusButton;
